import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const useSafeNavigate = (hasUnsavedChanges: boolean) => {
  const navigate = useNavigate();
  const [pendingPath, setPendingPath] = useState<string | null>(null);
  const [isModalOpen, setModalOpen] = useState(false);

  const requestNavigation = (path: string) => {
    if (hasUnsavedChanges) {
      setPendingPath(path);
      setModalOpen(true);
    } else {
      navigate(path);
    }
  };

  const confirmNavigation = () => {
    if (pendingPath) {
      navigate(pendingPath);
      setPendingPath(null);
    }
    setModalOpen(false);
  };

  const cancelNavigation = () => {
    setPendingPath(null);
    setModalOpen(false);
  };

  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (hasUnsavedChanges) {
        e.preventDefault();
        return '';
      }
    };

    if (hasUnsavedChanges) {
      window.addEventListener('beforeunload', handleBeforeUnload);
    }

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [hasUnsavedChanges]);

  return {
    requestNavigation,
    confirmNavigation,
    cancelNavigation,
    isModalOpen
  };
};
